import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { BodyText, Heading, Icon } from "../../elements";
import NestedImageSwiperSlide from "./nested-image-swiper-slide";
import Swiper from "swiper";
import lodash from "lodash";
import "./style.scss";
const NestedImageSwiper = props => {
  const { lang, fields, rendering, page } = props;
  const isAR = page?.fields?.rtl?.value;
  const { paddingTop, paddingBottom, gridType, title, titleType, slides } = fields;
  const top = paddingTop?.fields.phrase.value ?? "none";
  const bottom = paddingBottom?.fields.phrase.value ?? "none";
  const grid = gridType?.fields.phrase.value ?? "none";
  const gridClass = grid === "mini" ? "grid-mini" : "grid";
  const _activeSlides = {};
  const slideGroups = slides.reduce((prev, current) => {
    let last;
    if (prev.length > 0) {
      last = prev[prev.length - 1];
      if (last.length === 3) {
        last = [];
        prev.push(last);
        _activeSlides[prev.length - 1] = current;
      }
    } else {
      last = [];
      prev.push(last);
      _activeSlides[prev.length - 1] = current;
    }
    last.push(current);
    return prev;
  }, []);
  const rootEl = useRef(null);
  const swiperEl = useRef(null);
  const swiper = useRef(null);
  const [contentWidth, setContentWidth] = useState(0);
  const [activeSlide, setActiveSlide] = useState(isAR ? slides[slides.length - 3] : slides[0]);
  const activeSlides = useRef(_activeSlides);
  const onResize = e => {
    buildSwiper();
  };
  const buildSwiper = () => {
    if(!rootEl.current)  return null ;
    if (swiper.current) {
      swiper.current.destroy(true, true);
    }
    setContentWidth(rootEl.current.querySelector(".grid-content").clientWidth);
    swiper.current = new Swiper(swiperEl.current, {
      slidesPerView: 1,
      spaceBetween: 20,
      initialSlide: isAR ? slideGroups.length : 0,
      navigation: {
        nextEl: ".c-nested-image-swiper__main .swiper-prev",
        prevEl: ".c-nested-image-swiper__main .swiper-next",
      },
      on: {
        slideChange() {
          if(swiper.current){
            const _activeSlide = activeSlides.current[swiper.current.realIndex];
            setActiveSlide(_activeSlide);
          }
        }
      }
    });
  };
  const onActiveSlideChange = slide => {
    let __activeSlides = { ...activeSlides.current };
    __activeSlides[swiper.current.realIndex] = slide;
    setActiveSlide(slide);
    console.log("activeSlides", swiper.current.realIndex, slide, __activeSlides);
    activeSlides.current = __activeSlides;
  };
  const rootClasses = classNames("c-nested-image-swiper", gridClass, `padding-bottom-${bottom}`, `padding-top-${top}`);
  const contentClass = classNames(["grid-content", { "full-width": grid === "full-width" }]);
  useEffect(() => {
    setTimeout(v=>{
      buildSwiper();
    },100)
    window.addEventListener("resize", onResize);
    return () => {
      if (swiper.current) {
        swiper.current.destroy(true, true);
      }
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return (
    <div className={rootClasses} data-source={rendering.uid} ref={rootEl} style={{ "--slide-height": (contentWidth * 9) / 16 + "px", "--content-width": contentWidth + "px" }}>
      <div className={contentClass} dir="ltr">
        <Heading className="c-nested-image-swiper__title" html={title} type={titleType} />
        {activeSlide && <BodyText className="c-nested-image-swiper__description" html={activeSlide.fields.description} />}
        <div className="c-nested-image-swiper__main">
          <div className="swiper-container" ref={swiperEl}>
            <div className="swiper-wrapper">
              {slideGroups.map((group, i) => (
                <div className="swiper-slide" key={i}>
                  <NestedImageSwiperSlide slides={group} contentWidth={contentWidth} onChange={onActiveSlideChange} />
                </div>
              ))}
            </div>
          </div>
          <Icon name="ArrowBack" className="swiper-prev" />
          <Icon name="ArrowForward" className="swiper-next" />
        </div>
      </div>
    </div>
  );
};

export default NestedImageSwiper;
